import tagTester from './_tagTester.js';

export default tagTester('RegExp');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/isRegExp.js
// module id = 1582
// module chunks = 106